import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import InfoTooltip from './InfoTooltip'; // Reusable Tooltip
import { useTheme, alpha } from '@mui/material/styles';

const StatCard = ({ title, value, tooltip, color }) => {
  const theme = useTheme();

  // Determine background color based on the `color` prop
  let backgroundColor = 'background.paper';
  if (color === 'primary') {
    backgroundColor = alpha(theme.palette.primary.main, 0.1);
  } else if (color === 'secondary') {
    backgroundColor = alpha(theme.palette.secondary.main, 0.1);
  } else if (color === 'grey') {
    backgroundColor = theme.palette.grey[100];
  }

  return (
    <Card
      sx={{
        minWidth: 200,
        boxShadow: 0,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        backgroundColor: backgroundColor,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <CardContent>
        {/* Title and Tooltip */}
        {title && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start', // Align title and tooltip to the left
              mb: 1,
            }}
          >
            <Typography variant="subtitle1" component="div" sx={{ mr: 1 }}>
              {title}
            </Typography>
            {tooltip && <InfoTooltip title={tooltip} />}
          </Box>
        )}

        {/* Value and SubValue */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: title ? 'flex-start' : 'center', // Center if no title
            flexDirection: 'row',
            textAlign: 'center',
          }}
        >
          <Typography variant="h5" component="div" sx={{ mr: 1 }}>
            {value.main}
          </Typography>
          {value.sub && (
            <Typography
              variant="body2"
              component="span"
              sx={{
                color: 'text.secondary',
                fontSize: '1rem',
                whiteSpace: 'nowrap', // Prevent wrapping of the date
              }}
            >
              ({value.sub})
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatCard;
